import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import ReferredMerchants from '@/plugins/graphql/queries/v2/network_distributor/referred-merchants.gql';
import BaseSearchInput from '@/components/v2/BaseSearchInput';
import SearchMixin from '@/helpers/vue_mixins/v2/SearchMixin';
import AffiliateInviteForm from '@/components/v2/affiliate/AffiliateInviteForm.vue';
import ActionButton from '@/components/action_button/Index.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import { AppAffiliateModel } from '@/helpers/entities/models/AppAffiliateModel';
import { Getter } from 'vuex-class';
import { enumValueNormalizer } from '@/helpers/enum_value_normalizer';
import { Plans } from '@/helpers/entities/enums/v2/FilterSelection';
import { selectOptionBuilder } from '@/helpers/select_option_builder/index';
import moment from 'moment';
import { SHORTDATE_FORMAT } from '@/helpers/constants/app';
let MerchantsByStatus = class MerchantsByStatus extends Mixins(ViewportSizeMixin, SearchMixin) {
    constructor() {
        super(...arguments);
        this.plan = null;
        this.merchants = [];
        this.totalCount = 0;
        this.rangeFrom = moment('2020-01-01').startOf('year').format(SHORTDATE_FORMAT);
        this.rangeTo = moment().format(SHORTDATE_FORMAT);
    }
    get merchantStatus() {
        if (this.$route.params.status === 'unlaunched') {
            return 'pending';
        }
        return this.$route.params.status;
    }
    get queryOnFlight() {
        return this.$apollo.queries.merchants.loading;
    }
    get humanizedStatus() {
        if (this.merchantStatus === 'activated') {
            return 'Active';
        }
        if (this.merchantStatus === 'pending') {
            return 'Unlaunched';
        }
        if (this.merchantStatus === 'deactivated') {
            return 'Deactivated';
        }
        return 'Inactive';
    }
    get merchantCountLabel() {
        return `${this.humanizedStatus} Merchants`;
    }
    get headers() {
        return [
            {
                text: 'MERCHANT NAME',
                value: 'merchantName',
                align: 'left',
                sortable: false,
            },
            {
                text: 'MERCHANT ID',
                value: 'merchantId',
                align: 'left',
                sortable: false,
            },
            {
                text: 'PLAN TYPE',
                value: 'planType',
                align: 'left',
                sortable: false,
            },
            {
                text: 'ACTIVE SALES CHANNELS',
                value: 'activeSalesChannel',
                align: 'left',
                sortable: false,
            },
            {
                text: 'DATE LAUNCHED',
                value: 'dateLaunched',
                align: 'left',
                sortable: false,
            },
            {
                text: 'STORE OWNER',
                value: 'storeOwner',
                align: 'left',
                sortable: false,
            },
            {
                text: 'TOTAL ORDERS',
                value: 'totalOrders',
                align: 'left',
                sortable: false,
            },
            {
                text: 'ACCUMULATED CONVENIENCE FEES',
                value: 'accumulatedCovenienceFee',
                align: 'left',
                sortable: false,
            },
            {
                text: '',
                value: '',
                align: 'left',
                sortable: false,
            },
        ];
    }
    goToDetails(uuid) {
        this.$router.push({
            name: 'reseller-specific-merchant-details',
            params: { merchantUuid: uuid },
        });
    }
    formattedLaunchedDate(date) {
        const launchDate = new Date(date);
        return moment(launchDate).format('LLL');
    }
    humanizedPlanType(planType) {
        return enumValueNormalizer(planType);
    }
    queryVariables() {
        return {
            reseller: this.resellerUuid,
            status: this.merchantStatus,
            keywords: this.search,
            planType: this.plan,
            startDate: this.rangeFrom,
            endDate: this.rangeTo,
        };
    }
    get planOptions() {
        return [
            selectOptionBuilder(Plans.freeStarter),
            selectOptionBuilder(Plans.proMsme),
            selectOptionBuilder(Plans.proStarter),
            selectOptionBuilder(Plans.proBronze),
            selectOptionBuilder(Plans.proSilver),
            selectOptionBuilder(Plans.proGold),
            selectOptionBuilder(Plans.proPlatinum),
            selectOptionBuilder(Plans.proDiamond),
            selectOptionBuilder(Plans.proMythical),
            selectOptionBuilder(Plans.proPremium),
        ];
    }
    get today() {
        return moment().format(SHORTDATE_FORMAT);
    }
};
__decorate([
    Getter('resellerUuid')
], MerchantsByStatus.prototype, "resellerUuid", void 0);
MerchantsByStatus = __decorate([
    Component({
        apollo: {
            merchants: {
                query: ReferredMerchants,
                variables() {
                    return {
                        ...this.queryVariables(),
                    };
                },
                fetchPolicy: 'cache-and-network',
                update(data) {
                    const merchants = data.adminApps.edges;
                    const merchantNodes = (merchant) => {
                        return new AppAffiliateModel(merchant.node);
                    };
                    this.totalCount = data.adminApps.totalCount;
                    return merchants.map(merchantNodes);
                },
            },
        },
        components: {
            BaseSearchInput,
            ActionButton,
            AffiliateInviteForm,
        },
    })
], MerchantsByStatus);
export default MerchantsByStatus;
